import { GetTimeFromTimestamp, Resource } from '@dave/types';
import { CustomFields } from '../../../custom-form-fields/custom-form-fields.helper';
import { AccountsReceivableLedgerEntity } from '../accounts-receivable-ledger.entity';

export enum AmountTypeEnum {
    Centimeter = 'CENTIMETER',
    Gramm = 'GRAMM',
    Kilogramm = 'KILOGRAMM',
    Kilometer = 'KILOMETER',

    Kubikcentimeter = 'KUBIKCENTIMETER',
    Kubikkilometer = 'KUBIKKILOMETER',
    Kubikmeter = 'KUBIKMETER',
    Liter = 'LITER',

    Meter = 'METER',
    Quadratcentimeter = 'QUADRATCENTIMETER',
    Quadratkilometer = 'QUADRATKILOMETER',
    Quadratmeter = 'QUADRATMETER',

    Std = 'STD',
    Stk = 'STK',
    Tone = 'TONE',
    Laufendermeter = 'LAUFENDERMETER',
    Tag = 'TAG',
    Rolle = 'ROLLE',
    Dose = 'DOSE',
}

export const AmountTypeEnumNames = new Map<AmountTypeEnum, string>([
    [AmountTypeEnum.Gramm, 'g'],
    [AmountTypeEnum.Kilogramm, 'kg'],
    [AmountTypeEnum.Kilometer, 'km'],
    [AmountTypeEnum.Liter, 'l'],

    [AmountTypeEnum.Std, 'Std'],
    [AmountTypeEnum.Stk, 'Stk.'],
    [AmountTypeEnum.Tone, 'TO'],
    [AmountTypeEnum.Meter, 'm'],

    [AmountTypeEnum.Centimeter, 'cm'],
    [AmountTypeEnum.Kubikcentimeter, 'cm3'],
    [AmountTypeEnum.Kubikkilometer, 'km3'],
    [AmountTypeEnum.Kubikmeter, 'm3'],
    [AmountTypeEnum.Quadratcentimeter, 'cm2'],
    [AmountTypeEnum.Quadratkilometer, 'km2'],
    [AmountTypeEnum.Quadratmeter, 'm2'],
    [AmountTypeEnum.Laufendermeter, 'lfm'],
    [AmountTypeEnum.Tag, 'd'],
    [AmountTypeEnum.Rolle, 'Rolle'],
    [AmountTypeEnum.Dose, 'Dose'],
]);
export const AmountTypeEnumNamesLong = new Map<AmountTypeEnum, string>([
    [AmountTypeEnum.Gramm, 'Gramm'],
    [AmountTypeEnum.Kilogramm, 'Kilogramm'],
    [AmountTypeEnum.Kilometer, 'Kilometer'],
    [AmountTypeEnum.Liter, 'Liter'],

    [AmountTypeEnum.Std, 'Stunde'],
    [AmountTypeEnum.Stk, 'Stück'],
    [AmountTypeEnum.Tone, 'Tonne'],
    [AmountTypeEnum.Meter, 'Meter'],

    [AmountTypeEnum.Centimeter, 'Zentimeter'],
    [AmountTypeEnum.Kubikcentimeter, 'Kubikzentimeter'],
    [AmountTypeEnum.Kubikkilometer, 'Kubikkilometer'],
    [AmountTypeEnum.Kubikmeter, 'Kubikmeter'],
    [AmountTypeEnum.Quadratcentimeter, 'Quadratzentimeter'],
    [AmountTypeEnum.Quadratkilometer, 'Quadratkilometer'],
    [AmountTypeEnum.Quadratmeter, 'Quadratmeter'],
    [AmountTypeEnum.Laufendermeter, 'LaufenderMeter'],
    [AmountTypeEnum.Tag, 'Tag'],
    [AmountTypeEnum.Rolle, 'Rolle'],
    [AmountTypeEnum.Dose, 'Dose'],
]);
export class ResourceEntity {
    constructor(
        public Id: number = null,
        public ResourceTypeId: number = null,
        public Amount: number = null,
        // public FileId: number = null,
        public Cost: number = null,
        public MinChargeRate: number = null,
        public MaxChargeRate: number = null,
        public Name: string = null,
        public Kostenstelle: string = null,
        public AmountType: AmountTypeEnum = null,
        public Manufacturer: string = null,
        public ArticleNumber: string = null,
        public CustomFields: CustomFields[] = null,
        public UpdatedAt: Date = null,
        public DeletedAt: Date = null,
        public InventoryNumber: string = null,
        public QuantityTypeId: number = null,
        public StorageLocation: string = null,
        public GlobalTradeItemNr: string = null,
    ) {}
    public static EntityName = 'Gerät';

    public Clone(override: Partial<ResourceEntity> = {}): ResourceEntity {
        const attr = { ...this, ...override };
        return Object.assign(new ResourceEntity(), attr);
    }
    public get DisplayName() {
        return [this.ArticleNumber, this.Name].filter((x) => x).join(' ');
    }
    get ARLValues(): Pick<AccountsReceivableLedgerEntity, 'BookingText' | 'Information' | 'QuantityTypeId'> {
        return {
            BookingText: this.ArticleNumber,
            Information: this.Name,
            QuantityTypeId: this.QuantityTypeId,
        }
    }
}

export function ResourceEntityFromBackend(res: Resource): ResourceEntity {
    const amountTypeEnumValue = res.AmountType ? AmountTypeEnum[res.AmountType as keyof typeof AmountTypeEnum] : null;

    return new ResourceEntity(
        res.Id && +res.Id,
        res.ResourceTypeId && +res.ResourceTypeId,
        res.Amount && +res.Amount,
        // res.fileId,
        res.Cost && +res.Cost,
        res.MinChargeRate && +res.MinChargeRate,
        res.MaxChargeRate && +res.MaxChargeRate,
        res.Name,
        res.Kostenstelle,
        amountTypeEnumValue,
        res.Manufacturer,
        res.ArticleNumber,
        res.CustomFields && JSON.parse(res.CustomFields),
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.DeletedAt && GetTimeFromTimestamp(+res.DeletedAt),
        res.InventoryNumber,
        res.QuantityTypeId && +res.QuantityTypeId,
        res.StorageLocation,
        res.GlobalTradeItemNr,
    );
}
